import React from 'react';
import clsx from 'clsx';
import parse from 'html-react-parser';

import { Notification } from '@auspost/postmaster-react';

import { deleteNotification } from 'store/notification';
import { useAppDispatch, useAppSelector } from 'store/store';

import { NOTIFICATION_TEST_ID } from './Notification.test-ids';

import styles from './Notification.module.scss';

interface NotificationProps {
  className?: string;
}

const NotificationComponent: React.FC<NotificationProps> = ({ className, ...props }) => {
  const dispatch = useAppDispatch();
  const notifications = useAppSelector((state) => state.notification?.notifications);

  const onDismissNotification = (index: number) => dispatch(deleteNotification(index));

  const [notificationCount, setNotificationCount] = React.useState(0);

  const usePrevious = (value?: number) => {
    const ref = React.useRef(0);
    React.useEffect(() => {
      ref.current = value || 0;
    });
    return ref.current;
  };
  const previousNotificationCount = usePrevious(notificationCount) || 0;

  React.useEffect(() => {
    if (notificationCount >= previousNotificationCount) {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }
  }, [previousNotificationCount, notificationCount]);

  if (notifications.length != notificationCount) {
    setNotificationCount(notifications.length);
  }

  const displayBanner = notifications?.map((banner, index) => (
    <div className={styles.notification} key={index} data-testid={NOTIFICATION_TEST_ID}>
      <Notification
        type={banner.type}
        status={banner.status}
        message={parse(`${banner.message}`)}
        isDismissible={banner.canClose}
        handleDismiss={() => {
          banner.canClose && onDismissNotification(index);
        }}
      />
    </div>
  ));

  if (!notifications.length) return null;
  return (
    <div className={clsx(styles.bannerWrapper, className)} {...props}>
      {displayBanner}
    </div>
  );
};

export default NotificationComponent;
